/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDto } from './CreateDiscreteNumericListDto';
import {
    CreateDiscreteNumericListDtoFromJSON,
    CreateDiscreteNumericListDtoFromJSONTyped,
    CreateDiscreteNumericListDtoToJSON,
} from './CreateDiscreteNumericListDto';

/**
 * 
 * @export
 * @interface CreateBeamQualityDoseRateValueListDto
 */
export interface CreateBeamQualityDoseRateValueListDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBeamQualityDoseRateValueListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBeamQualityDoseRateValueListDto
     */
    beamQualityId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBeamQualityDoseRateValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {CreateDiscreteNumericListDto}
     * @memberof CreateBeamQualityDoseRateValueListDto
     */
    selectedDoseRates?: CreateDiscreteNumericListDto;
    /**
     * 
     * @type {string}
     * @memberof CreateBeamQualityDoseRateValueListDto
     */
    $type?: CreateBeamQualityDoseRateValueListDtoTypeEnum;
}


/**
 * @export
 */
export const CreateBeamQualityDoseRateValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateBeamQualityDoseRateValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateBeamQualityDoseRateValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateBeamQualityDoseRateValueListDtoTypeEnum = typeof CreateBeamQualityDoseRateValueListDtoTypeEnum[keyof typeof CreateBeamQualityDoseRateValueListDtoTypeEnum];


/**
 * Check if a given object implements the CreateBeamQualityDoseRateValueListDto interface.
 */
export function instanceOfCreateBeamQualityDoseRateValueListDto(value?: unknown): value is CreateBeamQualityDoseRateValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateBeamQualityDoseRateValueListDtoTypeEnum)[0];
}

export function CreateBeamQualityDoseRateValueListDtoFromJSON(json: any): CreateBeamQualityDoseRateValueListDto {
    return CreateBeamQualityDoseRateValueListDtoFromJSONTyped(json, false);
}

export function CreateBeamQualityDoseRateValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBeamQualityDoseRateValueListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'beamQualityId': !exists(json, 'beamQualityId') ? undefined : json['beamQualityId'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'selectedDoseRates': !exists(json, 'selectedDoseRates') ? undefined : CreateDiscreteNumericListDtoFromJSON(json['selectedDoseRates']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateBeamQualityDoseRateValueListDtoToJSON(value?: CreateBeamQualityDoseRateValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'beamQualityId': value.beamQualityId,
        'isEnabled': value.isEnabled,
        'selectedDoseRates': CreateDiscreteNumericListDtoToJSON(value.selectedDoseRates),
        '$type': value.$type,
    });
}

